import { useTranslation } from 'react-i18next';
import { usePTPConfigContext } from 'GlobalConfig.context';
import { Stepper } from '../Stepper';

export const PrepareReturnShipmentSteps = (): JSX.Element => {
  const { t } = useTranslation();
  const {
    return: { customText },
  } = usePTPConfigContext();

  const steps = [
    {
      title: t('RETURN_DOWNLOAD_QR_TITLE'),
      subText: t('RETURN_DOWNLOAD_QR_SUBTEXT'),
      customText: customText.shippingInstructionStep1.text,
    },
    {
      title: t('RETURN_DROP_OFF_PARCEL_TITLE'),
      subText: t('RETURN_DROP_OFF_PARCEL_SUBTEXT'),
      customText: customText.shippingInstructionStep2.text,
    },
    {
      title: t('RETURN_REFUND_PROCESSING_TIME_TITLE'),
      subText: t('RETURN_REFUND_PROCESSING_TIME_SUBTEXT'),
      customText: customText.shippingInstructionStep3.text,
    },
  ];

  return <Stepper steps={steps} />;
};
